// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"input_wrapper__3Juod","withIcon":"input_withIcon__Zk5jC","icon":"input_icon__34_HV","newForm":"input_newForm__vEdUn","newIcon":"input_newIcon__2ceGk"};